(() => {
  'use strict';

  const initFeed = (section) => {
    if (!section || section.dataset.mhInstagramReady === 'true') return;
    section.dataset.mhInstagramReady = 'true';
    const feed = section.querySelector('[data-mh-instagram-feed]');
    if (!feed) return;

    const update = () => {
      const hasLiveContent = Boolean(
        feed.querySelector('a[href], img, video, iframe, [data-instafeed-item], .instafeed-container')
      );
      section.classList.toggle('is-app-live', hasLiveContent);
    };

    update();
    if ('MutationObserver' in window) {
      const observer = new MutationObserver(update);
      observer.observe(feed, { childList: true, subtree: true });
    }
  };

  const initAll = () => document.querySelectorAll('[data-mh-instagram-ugc]').forEach(initFeed);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
